/* ============================================
   NZ BOUTON ATC — Script
   ============================================ */
(function () {
  'use strict';

  var ATC_SELECTORS = [
    '[name="add"]',
    '.product-form__submit',
    'button[type="submit"].btn',
    '.shopify-payment-button button',
  ].join(',');

  /* Injecte l'icône coche et la classe dans chaque bouton ATC */
  function enhance(btn) {
    if (btn.dataset.nzAtcEnhanced) return;
    btn.dataset.nzAtcEnhanced = '1';
    btn.classList.add('nz-atc-btn');

    /* Coche SVG */
    var check = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    check.setAttribute('class', 'nz-atc-check');
    check.setAttribute('width', '16');
    check.setAttribute('height', '16');
    check.setAttribute('viewBox', '0 0 24 24');
    check.setAttribute('fill', 'none');
    check.setAttribute('stroke', '#fff');
    check.setAttribute('stroke-width', '2.5');
    check.setAttribute('stroke-linecap', 'round');
    check.setAttribute('stroke-linejoin', 'round');
    var poly = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
    poly.setAttribute('points', '20 6 9 17 4 12');
    check.appendChild(poly);
    btn.insertBefore(check, btn.firstChild);

    /* Écoute le clic */
    btn.addEventListener('click', function (e) {
      /* Ripple */
      var r = document.createElement('span');
      r.className = 'nz-ripple-el';
      r.style.left = (e.offsetX || btn.offsetWidth / 2) + 'px';
      r.style.top  = (e.offsetY || btn.offsetHeight / 2) + 'px';
      btn.appendChild(r);
      setTimeout(function () { r.remove(); }, 600);

      /* Pop */
      btn.classList.add('nz-atc-clicking');
      setTimeout(function () { btn.classList.remove('nz-atc-clicking'); }, 360);
    });
  }

  /* Détecte l'ajout réussi au panier via l'event Shopify */
  function onSuccess(btn) {
    var original = btn.textContent.trim();
    btn.classList.add('nz-atc-success');
    /* Remplace le texte */
    var textNode = Array.from(btn.childNodes).find(function (n) {
      return n.nodeType === Node.TEXT_NODE && n.textContent.trim();
    });
    if (textNode) textNode.textContent = ' Ajouté !';

    setTimeout(function () {
      btn.classList.remove('nz-atc-success');
      if (textNode) textNode.textContent = ' ' + original;
    }, 2000);
  }

  /* Observe les boutons existants et futurs */
  function init() {
    document.querySelectorAll(ATC_SELECTORS).forEach(enhance);
    new MutationObserver(function () {
      document.querySelectorAll(ATC_SELECTORS).forEach(enhance);
    }).observe(document.body, { childList: true, subtree: true });

    /* Écoute l'event natif Shopify "cart:item-added" */
    document.addEventListener('cart:item-added', function () {
      document.querySelectorAll('.nz-atc-btn').forEach(onSuccess);
    });

    /* Fallback : intercepte fetch /cart/add.js */
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      return origFetch.apply(this, arguments).then(function (res) {
        if (url.includes('/cart/add')) {
          var clone = res.clone();
          clone.json().then(function (data) {
            if (data && (data.id || data.items)) {
              document.querySelectorAll('.nz-atc-btn').forEach(onSuccess);
            }
          }).catch(function () {});
        }
        return res;
      });
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
